export const ACCOUNTS_PAGE_FILTERS = {
  QUERY: 'query',
  ACCOUNT_STATUS: 'accountStatus',
  ACCOUNT_PRICING_PLAN: 'plan.planDefinition.pricingPlan',
  ACCOUNT_SUBDOMAIN: 'subDomainName',
};
